import { useParams } from 'react-router-dom'
import React from 'react'
import EventForm from './form'

export default function EventsEditPage() {
  const params = useParams()

  return <EventForm eventId={params.slug} isNew={!params.slug} />
}
